import { useTheme } from '../theme/ThemeProvider';
import { Icon } from '../icons/Icon';
import type { OperationProgressProps } from './OperationProgress';

export function OperationProgress({
  title,
  description,
  icon,
  compact = false,
  inverse = false,
  testID,
}: OperationProgressProps) {
  const theme = useTheme();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={[title, description].filter(Boolean).join('. ')}
      data-testid={testID}
      className={`operation-progress operation-feedback${compact ? ' operation-progress--compact' : ''}`}
      style={{
        color: inverse ? theme.colors.textInverse : theme.colors.text,
        fontFamily: theme.fontFamilyBase,
      }}
    >
      <span
        className="operation-progress__indicator"
        aria-hidden="true"
        style={{ color: inverse ? theme.colors.textInverse : theme.colors.primary }}
      >
        <i className="fal fa-spinner-third fa-spin operation-progress__loader" aria-hidden="true" />
        {icon && (
          <span className="operation-progress__icon">
            <Icon name={icon} size={compact ? 12 : 20} tone={inverse ? 'inverse' : 'primary'} />
          </span>
        )}
      </span>
      <div className="operation-progress__text">
        <div className="operation-progress__title">{title}</div>
        {description && (
          <div style={{ color: inverse ? theme.colors.textInverseMuted : theme.colors.textMuted }}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
}
